import { THEME } from 'styles/themes';

export const colors = THEME.Interactions.colors ?? {};

export const typography = THEME.Interactions.typography ?? {};

export const options = THEME.Navbar.options ?? {};
